import { useState } from "react";
import { MapPin, Mail, Phone, Clock } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", phone: "", message: "" });
  const submit = (e) => {
    e.preventDefault();
    toast.success("Thank you. Our concierge will be in touch shortly.");
    setF({ name: "", email: "", phone: "", message: "" });
  };
  return (
    <div data-testid="contact-page" className="max-w-[1200px] mx-auto px-6 lg:px-10 py-16">
      <div className="text-center mb-16">
        <div className="eyebrow">The Concierge</div>
        <h1 className="font-serif-luxe text-5xl text-[#FAF8F5] mt-3">Book a Private Viewing</h1>
        <p className="text-[#C2B29F] mt-4 max-w-xl mx-auto">Speak to our team for bespoke commissions, bridal trousseau or a private atelier visit.</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
        <div className="lg:col-span-3">
          <form onSubmit={submit} className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <label className="block"><span className="text-[11px] tracking-[0.14em] uppercase text-[#C2B29F]">Name</span>
                <input data-testid="contact-name" required value={f.name} onChange={e => setF({...f, name: e.target.value})} className="mt-2 w-full bg-transparent border border-[#D4AF37]/25 px-3 py-2.5 text-sm text-[#FAF8F5] focus:border-[#D4AF37] focus:outline-none"/>
              </label>
              <label className="block"><span className="text-[11px] tracking-[0.14em] uppercase text-[#C2B29F]">Phone</span>
                <input data-testid="contact-phone" required value={f.phone} onChange={e => setF({...f, phone: e.target.value})} className="mt-2 w-full bg-transparent border border-[#D4AF37]/25 px-3 py-2.5 text-sm text-[#FAF8F5] focus:border-[#D4AF37] focus:outline-none"/>
              </label>
            </div>
            <label className="block"><span className="text-[11px] tracking-[0.14em] uppercase text-[#C2B29F]">Email</span>
              <input data-testid="contact-email" type="email" required value={f.email} onChange={e => setF({...f, email: e.target.value})} className="mt-2 w-full bg-transparent border border-[#D4AF37]/25 px-3 py-2.5 text-sm text-[#FAF8F5] focus:border-[#D4AF37] focus:outline-none"/>
            </label>
            <label className="block"><span className="text-[11px] tracking-[0.14em] uppercase text-[#C2B29F]">Your message</span>
              <textarea data-testid="contact-message" required rows="5" value={f.message} onChange={e => setF({...f, message: e.target.value})} className="mt-2 w-full bg-transparent border border-[#D4AF37]/25 px-3 py-2.5 text-sm text-[#FAF8F5] focus:border-[#D4AF37] focus:outline-none"/>
            </label>
            <button data-testid="contact-submit" className="btn-gold">Send Enquiry</button>
          </form>
        </div>
        <div className="lg:col-span-2 space-y-6">
          <div className="flex gap-4"><MapPin className="text-[#D4AF37] mt-1" size={18}/><div><div className="eyebrow">Atelier</div><div className="text-sm text-[#FAF8F5] mt-1">Johari Bazaar, Jaipur 302003</div></div></div>
          <div className="flex gap-4"><Phone className="text-[#D4AF37] mt-1" size={18}/><div><div className="eyebrow">Concierge</div><div className="text-sm text-[#FAF8F5] mt-1">+91 98765 43210</div></div></div>
          <div className="flex gap-4"><Mail className="text-[#D4AF37] mt-1" size={18}/><div><div className="eyebrow">Email</div><div className="text-sm text-[#FAF8F5] mt-1">care@laxmiaura.com</div></div></div>
          <div className="flex gap-4"><Clock className="text-[#D4AF37] mt-1" size={18}/><div><div className="eyebrow">Hours</div><div className="text-sm text-[#FAF8F5] mt-1">Mon – Sat, 10:30am – 8pm</div></div></div>
        </div>
      </div>
    </div>
  );
}
